var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"webgl-header"},[_c('canvas',{ref:"webgl-header-canvas",staticClass:"webgl-header-canvas"})])}
var staticRenderFns = []

export { render, staticRenderFns }